import { ValidationErrorMessage } from './constants/validation-error.message';
import { TValidatorResponse } from './types/validator-response.types';

const BTC_ADDRESS_REGEX = /^([13])[a-km-zA-HJ-NP-Z1-9]{25,34}$|^bc1[ac-hj-np-z02-9]{39,59}$/;

export const isValidBtcAddress = (address: string): TValidatorResponse =>
  BTC_ADDRESS_REGEX.test(address) ? undefined : ValidationErrorMessage.IncorrectBtcAddress();
